// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ClientBriefAsset } from './clientBriefAsset.zod.ts';

export const ClientBriefOut = zod.object({
  "assets": zod.array(ClientBriefAsset),
  "client": zod.string(),
  "combinations": zod.array(zod.string()),
  "needs": zod.array(zod.string()),
  "prepared_line": zod.string(),
  "summary": zod.string()
});

export type ClientBriefOut = zod.input<typeof ClientBriefOut>;
export type ClientBriefOutOutput = zod.output<typeof ClientBriefOut>;
